var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaculty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 15.75C10.7403 15.75 12.8333 13.7318 12.8333 11.25C12.8333 8.76825 10.7403 6.75 8.16667 6.75C5.593 6.75 3.5 8.76825 3.5 11.25C3.5 13.7318 5.593 15.75 8.16667 15.75ZM8.16667 9C9.4535 9 10.5 10.0091 10.5 11.25C10.5 12.4909 9.4535 13.5 8.16667 13.5C6.87983 13.5 5.83333 12.4909 5.83333 11.25C5.83333 10.0091 6.87983 9 8.16667 9ZM16.3333 25.875C16.3333 26.4971 15.8107 27 15.1667 27C14.5227 27 14 26.4971 14 25.875C14 22.7734 11.3832 20.25 8.16667 20.25C4.95017 20.25 2.33333 22.7734 2.33333 25.875C2.33333 26.4971 1.81067 27 1.16667 27C0.522667 27 0 26.4971 0 25.875C0 21.5336 3.66333 18 8.16667 18C12.67 18 16.3333 21.5336 16.3333 25.875ZM28 5.625V14.625C28 17.7266 25.3832 20.25 22.1667 20.25H17.5C16.856 20.25 16.3333 19.7471 16.3333 19.125V16.875C16.3333 16.2529 16.856 15.75 17.5 15.75H21C21.644 15.75 22.1667 16.2529 22.1667 16.875V18C24.0963 18 25.6667 16.4858 25.6667 14.625V5.625C25.6667 3.76425 24.0963 2.25 22.1667 2.25H11.0425C9.7965 2.25 8.6345 2.89687 8.01033 3.93862C7.68717 4.47638 6.97433 4.662 6.41667 4.34812C5.85783 4.03762 5.66767 3.34913 5.99083 2.81138C7.0315 1.07775 8.967 0 11.0437 0H22.1678C25.3843 0 28 2.52338 28 5.625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_1237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaculty);
export default __webpack_public_path__ + "static/media/Faculty.af1aa5ddb9ee8ee31fb06179037e7594.svg";
export { ForwardRef as ReactComponent };